import AuditLogStore from "./AuditLog/AuditLogStore";
import IntegrationErrorsStore from "./IntegrationErrors/IntegrationErrorsStore";
import ApiKeysStore from "./ApiKeys/ApiKeysStore";
import DataExportStore from "./DataExport/DataExportStore";
import EmailAdminStore from "./Email/EmailAdminStore";
import TrackerImportStore from "./TrackerImport/TrackerImportStore";

/**
 * View stores for the /admin view group. Spread into `appStores` in
 * src/appStoresConfig.ts (same pattern as devopsStoreList et al.).
 * DatabaseManagerStore predates this list and stays registered directly
 * in appStoresConfig.ts.
 */
const adminStoreList = [
  { name: "auditLogViewStore", store: AuditLogStore },
  { name: "integrationErrorsViewStore", store: IntegrationErrorsStore },
  { name: "apiKeysViewStore", store: ApiKeysStore },
  { name: "dataExportViewStore", store: DataExportStore },
  { name: "emailAdminViewStore", store: EmailAdminStore },
  // NOT "trackerImportsStore": that is the `tracker-imports` ServiceStore's key.
  { name: "trackerImportViewStore", store: TrackerImportStore },
];

export default adminStoreList;
